export default __webpack_public_path__ + "static/media/allgemein_11.307a7f5e.jpg";